import React from 'react';
import { Card, Row, Col, Form, Button } from 'react-bootstrap';
import Select from 'react-select';
import { customStyles } from '~/Styles/reactSelectStyles';

const CabecalhoBusca = ({
  ge,
  geOptions,
  onGeChange,
  numeroProposta,
  onNumeroProposta,
  onBuscar,
  loading,
}) => {
  const geValue = geOptions.find((o) => o.value === ge) || null;

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') onBuscar();
  };

  return (
    <Card className="mb-2">
      <Card.Body>
        <Row className="align-items-end">
          <Col md={4}>
            <Form.Group>
              <Form.Label className="small mb-1">Grupo Empresa</Form.Label>
              <Select
                styles={customStyles}
                options={geOptions}
                value={geValue}
                onChange={(opt) => onGeChange(opt ? opt.value : null)}
                placeholder="Selecione..."
                isClearable
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label className="small mb-1">Nº Proposta</Form.Label>
              <Form.Control
                type="number"
                value={numeroProposta}
                onChange={(e) => onNumeroProposta(e.target.value)}
                onKeyPress={handleKeyPress}
                onBlur={onBuscar}
                placeholder="Ex.: 12345"
                disabled={loading}
              />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label className="small mb-1">&nbsp;</Form.Label>
              <Button onClick={onBuscar} disabled={loading} variant="primary" block>
                {loading ? 'Buscando...' : 'Buscar'}
              </Button>
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CabecalhoBusca;
